<script>
  import { layoutMethods  } from "@/state/helpers";
  // import { contactListData } from "./data-list";
  import { rouletteMethods,rouletteComputed ,erpFixMessages, exportMethods } from "@/state/helpers";
  import Swal from "sweetalert2";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  export default {
    page: {
      title: "Roulette Reward"
    },
    data() {
      return {
        title: "Roulette Reward",
        rewardListData: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90 ,100],
        filter: null,
        filterOn: [],
        sortBy: "value",
        sortDesc: false,
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Id Number', value: 'peddlrTrackingId' },
          { text: 'Name', value: 'receiverName' }
        ],
        filterOptions: [
          { text: 'All', value: null },
          { text: 'Claimed', value: 'Claimed' },
          { text: 'Processing', value:  'Processing'},
          { text: 'Sent for Delivery', value: 'Sent for Delivery' },
          { text: 'Delivered', value: 'Delivered' },
          { text: 'Cancelled', value: 'Cancelled' }
        ],
        filterValue: {
            name: null,
            field: 'peddlrTrackingId',
        },
        searchValue: {
            name: null,
            field: null,
            dateRange: null,
        },
        fields: [
          //  {
          //   key: "action",
          //   sortable: false,
          // },
          {
            key: "id_number",
            sortable: true,
          }, 
          {
            key: "name",
            sortable: true,
          },
          {
            key: "item_description",
            sortable: true,
          },
          {
            key: "deliveryStatus",
            sortable: true,
          },
          {
            key: "process_date",
            label:"Delivery Date",
            sortable: true,
          },
          {
            key: "wheel_type",
            sortable: true,
          },
        ],
        pagination: {
            "page": 1,
            "rows" : 10,
            "sort": "fwr.id",
            "orderDesc": true,
            "search": "",
            "search_field":  "",
            "filter":  "",
            "filter_by": "",
            "dateRange": null,
        },
        rangeOptions: {
          mode: "range",
        }
      };
    },
    components: { 
      flatPickr,
    },
    computed: {
      ...rouletteComputed,
      ...erpFixMessages
    },
    methods: {
      ...layoutMethods,
      ...rouletteMethods,
      ...exportMethods,
      async onExport(){
        await this.onPageUpdate();
        if(this.rewardsTotalRows ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        // var search_value_holder = this.searchValue;
        let params = Object.assign(
          // this.pagination.search = this.searchValue.name;
          // this.pagination.search_field = this.searchValue.field;
          // this.pagination.filter = this.filterValue.name;
          // this.pagination.filter_by = this.filterValue.field;
          // this.pagination.dateRange = this.searchValue.dateRange;
          {
            module: 'roulette_list',
            email: JSON.parse(localStorage.getItem('userData')).email,
            search  : this.pagination.search,
            search_field  : this.pagination.search_field,
            filter  : this.pagination.filter,
            filter_by : this.pagination.filter_by,
            dateRange : this.pagination.dateRange,
            sort: this.pagination.sort,
            orderDesc: this.pagination.orderDesc
          });

        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
      populateRouletteRewards(){
        this.onPageUpdate();
      },
      async onPageUpdate() {
          this.pagination.search = this.searchValue.name;
          this.pagination.search_field = this.searchValue.field;
          this.pagination.filter = this.filterValue.name;
          this.pagination.filter_by = this.filterValue.field;
          this.pagination.dateRange = this.searchValue.dateRange;
          await this.listRouletteReward(this.pagination)
      },
      refresh(){
        this.searchValue.name = null;
        this.filterValue.name = null;
        //this.pagination.page = 1;
        this.populateRouletteRewards();
        
      },
      tableSorting(action){
        var column = "";
        switch(action.sortBy){
            case 'id_number' :
                column = 'fwr.peddlrTrackingId';
                break;
            case 'name' :
                column = 'fwr.receiverName';
                break;
            case 'item_description' :
                column = 'fwr.reward';
                break;
            case 'process_date' :
                column = 'fwr.processedDate';
                break;
            case 'deliveryStatus' :
                column = 'fwr.deliveryStatus';
                break;
        }
        this.pagination.sort = column;
        this.pagination.orderDesc = action.sortDesc;
        this.pagination.search = this.searchValue.name;
        this.pagination.search_field = this.searchValue.field;
        this.pagination.filter = this.filterValue.name;
        this.pagination.filter_by = this.filterValue.field;
        this.pagination.dateRange = this.searchValue.dateRange;
        console.log(this.pagination);
        this.listRouletteReward(this.pagination)
        
      }
    },
    mounted(){
      this.populateRouletteRewards();
      this.changeTitle({title: 'Roulette Reward'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Roulette Reward', to: { name: 'Roulette Reward'} }
        ]
      });
    }
  }
    
</script>

<template>
  <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4 mb-4">
                <div class="my-2">
                  <h5 class="card-title text-dark">
                    <span class="fw-normal ms-lg-2">{{rewardsTotalRows}}</span> Record(s)
                  </h5>
                </div>
              </div>

              <div class="col-md-8 col-sm-8">
                  <div class="d-flex justify-content-lg-end mb-lg-3">
                      <a class="btn btn-secondary"
                        @click="refresh"
                          ><feather
                          type="refresh-ccw"
                          size="16"
                          class="icon nav-icon"
                          ></feather
                          >&nbsp;&nbsp; Refresh</a
                      >
                  </div>
              </div>
              <div class="row">
                <div class="w-auto mb-2">
                  <div class="d-flex mt-3 mb-3">
                    <div class="me-3">
                      <form class="d-flex" @submit.prevent="onPageUpdate()">
                        <b-form-group id="input-group-3" label-for="input-3">
                          <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.field" :options="searchOptions"></b-form-select>
                        </b-form-group>
                        <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                          <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                          <b-form-input id="input-keyword" v-model="searchValue.name" class="rounded-0" style="width: auto"></b-form-input>
                        </b-form-group>
                      </form>
                    </div>
                    <div class="me-3 w-250px">
                      <b-form-group id="input-group-3" label-for="input-3">
                        <template v-slot:description><div class="d-flex justify-content-end">Filter By</div></template>
                        <b-form-select class="form-select rounded-0 rounded-start shadow-none w-150px" id="input-3" v-model="filterValue.name" :options="filterOptions"></b-form-select>
                      </b-form-group>
                    </div>
                    <div class="me-3 w-250px ta-right">
                        <b-form-group description="Filter by delivery date">
                          <flat-pickr
                            v-model="searchValue.dateRange"
                            :config="rangeOptions"
                            placeholder="Select a date range"
                            class="form-control"
                            style="width: fit-content"
                          ></flat-pickr>
                        </b-form-group>
                    </div>
                    <div class="me-3">
                      <b-form-group label="">
                        <b-button variant="primary" type="button" @click="onPageUpdate()" class="px-2 me-2">
                          <i class='bx bx-search bx-fw'></i>
                          Search
                        </b-button>
                        <b-button variant="primary" type="button" @click="onExport" class="px-2 me-2">
                          <i class="uil uil-export me-1"></i>
                          Export
                        </b-button>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="rouletteRewards"
                    :fields="fields"
                    responsive="sm"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @sort-changed="tableSorting"
                    class="table-check"
                  >
                    <!-- <template #cell(action)="data">
                        <div class="d-flex">
                          <div class="btn-group me-2 mb-2 mb-sm-0">
                              <button type="button" @click="addEditItem(data.item)"  class="btn btn-sm btn-primary">
                              <i class="bx bx-edit bx-xs bx-fw"></i>
                              </button>
                          </div>
                          <div>
                              <b-button id="show-btn" @click="deleteItem(data.item)" class="btn btn-sm btn-danger"><i class="bx bx-trash bx-xs bx-fw"></i></b-button>
                          </div>
                        </div>
                    </template> -->
                    <template #cell(id_number)="data">
                      <span class="text-body m-0"><router-link :to="{ name: 'Roulette Reward Edit', params: { peddlrTrackingId : data.item.peddlrTrackingId }}" class="customer-name">{{ data.item.peddlrTrackingId }}</router-link></span>
                    </template>

                    <template #cell(name)="data">
                      {{ data.item.receiverName }}
                    </template>
                    <template #cell(item_description)="data">
                      {{ data.item.reward }}
                    </template>
                    <template #cell(process_date)="data">
                      <span v-if="data.item.deliveryStatus =='Claimed'">
                        {{ data.item.updated_at | formatDateNoComma }}
                      </span>
                      <span v-else>
                        {{ data.item.processedDate | formatDateNoComma }}
                      </span>
                    </template>
                    <template #cell(wheel_type)="data">
                      {{ data.item.wheel_type }}
                    </template>
                    
                  </b-table>
                </div>
              </div>
              <div class="row g-0 text-center" v-if="rewardsTotalRows == 0">
                <span>No data to display.</span>
              </div>
              <div class="row g-0 text-center text-sm-start" v-if="rewardsTotalRows != 0 && rewardsTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="pagination.rows"
                            :options="pageOptions"
                            @change="onPageUpdate()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                    >
                      <!-- pagination -->
                      <div class="row g-0 text-center" v-if="rewardsTotalRows == 0">
                        <span>No data to display.</span>
                      </div>
                      <b-pagination
                        v-if="rewardsTotalRows != 0 && rewardsTotalRows > pagination.rows"
                        class="pagination-rounded"
                        v-model="pagination.page"
                        :total-rows="rewardsTotalRows"
                        @input="onPageUpdate()"
                        :per-page="pagination.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
</template>


<style scoped>
  .btn {
    cursor: pointer;
  }
</style>